<app-exported-files-table [sessionData]="sessionData$ | async" (download)="onDownload($event)"></app-exported-files-table>
